import { IStore } from 'store/configureStore';

export const selectDealsState = (state: IStore) => {
    return state.modules.settings.clientsSettings.clients.deals;
};
